export const GAMIFICATION_TOAST_SESSION_KEY = 'cfpl.gamification.toast.delivered';

const deliveredInMemory = new Set<string>();

function readSessionMarker(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.sessionStorage.getItem(GAMIFICATION_TOAST_SESSION_KEY);
  } catch {
    return null;
  }
}

function writeSessionMarker(latestEventId: string): void {
  deliveredInMemory.add(latestEventId);

  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.sessionStorage.setItem(GAMIFICATION_TOAST_SESSION_KEY, latestEventId);
  } catch {
    // sessionStorage may be unavailable; in-memory marker still suppresses remounts.
  }
}

export function hasGamificationToastBeenDelivered(latestEventId: string): boolean {
  if (deliveredInMemory.has(latestEventId)) {
    return true;
  }

  const stored = readSessionMarker();
  if (stored === latestEventId) {
    deliveredInMemory.add(latestEventId);
    return true;
  }

  return false;
}

export function markGamificationToastDelivered(latestEventId: string): void {
  writeSessionMarker(latestEventId);
}

/** Test-only: clear session + in-memory delivery markers. */
export function resetGamificationToastSessionForTests(): void {
  deliveredInMemory.clear();

  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.sessionStorage.removeItem(GAMIFICATION_TOAST_SESSION_KEY);
  } catch {
    // ignore
  }
}
